<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <div class="button-header">
        <button type="button" *ngIf="!close" [attr.aria-label]="labelBtnBack" [id]="id" (click)="back($event)" (focus)="focusHeader.emit()">
          <img aria-hidden="true" src="/assets/images/svg/arrow-left.svg" alt="icon">
        </button>
        <button type="button" *ngIf="close" aria-label="fechar" [id]="id" (click)="back($event)" (focus)="focusHeader.emit()">
          <img aria-hidden="true" src="/assets/images/svg/close.svg" alt="icon">
        </button>
        <ion-label *ngIf="title" (click)="clickLabel()" [ngClass]="{'flex-1' : start || end}">
          <h1 class="title-header">{{title}}</h1>
        </ion-label>
        <ion-label class="stage" [ngClass]="{'stageNot': start === 'false'}" *ngIf="start">
          <span role="text" attr.aria-label="passo {{start}} de {{end}}">{{start}} de {{end}}</span>
        </ion-label>
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
